<section class="message-page" *ngIf="vm$ | async as vm">
  <div class="message-card">
    <header class="message-heading">
      <div>
        <h1 class="sam-page-heading">{{adminUserId ? 'Medlemmens meddelanden' : 'Meddelanden'}}</h1>
        <p *ngIf="!detailId">{{vm.page.TotalCount}} meddelanden · {{vm.page.UnreadCount}} olästa</p>
      </div>
      <button *ngIf="!vm.readOnly && !detailId" mat-icon-button [matMenuTriggerFor]="messageMenu" aria-label="Alternativ för meddelanden" matTooltip="Alternativ">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #messageMenu="matMenu">
        <button mat-menu-item (click)="showPreferences()"><mat-icon>notifications_none</mat-icon><span>Pushnotiser</span></button>
      </mat-menu>
    </header>

    <div class="message-notice" *ngIf="vm.readOnly">
      <mat-icon aria-hidden="true">visibility</mat-icon>
      <p>Skrivskyddad visning. Meddelandena markeras inte som lästa av medlemmen.</p>
    </div>
    <a *ngIf="adminUserId && !detailId" class="back-link" mat-button [routerLink]="['/users', adminUserId]">
      <mat-icon>arrow_back</mat-icon>Till medlemmen
    </a>

    <div class="message-preferences" *ngIf="preferencesOpen && !vm.readOnly">
      <h2>Pushnotiser i mobilappen</h2>
      <p>Meddelanden finns kvar här även när pushnotiser är avstängda. Mobilappen behöver också ha tillåtelse att visa notiser.</p>
      <mat-slide-toggle [checked]="vm.pushEnabled === true" [disabled]="vm.preferencesBusy || vm.pushEnabled === null"
        (change)="savePush($event.checked)">Tillåt pushnotiser</mat-slide-toggle>
      <p *ngIf="vm.preferencesBusy" role="status">Hämtar eller sparar inställningen …</p>
      <div *ngIf="vm.preferencesError" role="alert"><p>{{vm.preferencesError}}</p><button mat-button (click)="reloadPreferences()">Försök igen</button></div>
    </div>

    <ng-container *ngIf="!detailId; else messageDetail">
      <div class="message-toolbar">
        <mat-button-toggle-group [value]="query.unreadOnly" (change)="filter({unreadOnly: $event.value})" aria-label="Lässtatus">
          <mat-button-toggle [value]="false">Alla</mat-button-toggle>
          <mat-button-toggle [value]="true">Olästa</mat-button-toggle>
        </mat-button-toggle-group>
        <mat-form-field appearance="outline">
          <mat-label>Typ av meddelande</mat-label>
          <mat-select [value]="query.type" (selectionChange)="filter({type: $event.value})">
            <mat-option value="All">Alla typer</mat-option><mat-option value="Personal">Personliga</mat-option><mat-option value="General">Allmänna</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="message-search">
          <mat-label>Sök meddelanden</mat-label>
          <mat-icon matPrefix>search</mat-icon><input matInput [ngModel]="query.search" (ngModelChange)="search($event)" maxlength="200">
          <button *ngIf="query.search" matSuffix mat-icon-button (click)="search('')" aria-label="Rensa sökning" matTooltip="Rensa sökning"><mat-icon>close</mat-icon></button>
        </mat-form-field>
        <button mat-icon-button (click)="retry()" [disabled]="vm.listLoading" aria-label="Uppdatera meddelanden" matTooltip="Uppdatera meddelanden"><mat-icon>refresh</mat-icon></button>
      </div>
      <div class="message-list-shell" [attr.aria-busy]="vm.listLoading">
        <div class="message-skeleton" *ngIf="vm.listLoading" role="status" aria-label="Hämtar meddelanden">
          <div *ngFor="let row of skeletonRows" class="message-skeleton-row" aria-hidden="true"><span></span><span></span></div>
        </div>
        <div *ngIf="!vm.listLoading && vm.listError" class="message-empty" role="alert"><p>{{vm.listError}}</p><button mat-flat-button color="accent" (click)="retry()">Försök igen</button></div>
        <div *ngIf="!vm.listLoading && !vm.listError && !vm.page.Items.length" class="message-empty">
          <mat-icon aria-hidden="true">mark_email_read</mat-icon><h2>{{query.unreadOnly ? 'Inga olästa meddelanden' : 'Inga meddelanden hittades'}}</h2>
          <p>{{query.search || query.type !== 'All' ? 'Prova en annan sökning eller typ av meddelande.' : 'Här visas personliga uppdateringar och allmän information.'}}</p>
        </div>
        <ul *ngIf="!vm.listLoading && !vm.listError && vm.page.Items.length" class="message-list">
          <li *ngFor="let message of vm.page.Items">
            <a class="message-row" [class.is-unread]="!message.IsRead" [routerLink]="detailRoute(message.Id)" [queryParams]="query">
              <mat-icon aria-hidden="true">{{message.IsRead ? 'drafts' : 'mark_email_unread'}}</mat-icon>
              <div class="message-copy">
                <div class="message-row-title"><strong>{{message.Title}}</strong><span class="message-unread" *ngIf="!message.IsRead">Oläst</span></div>
                <p>{{message.Summary}}</p>
                <span class="message-meta">{{message.Source === 'Personal' ? 'Personligt' : 'Allmänt'}} · {{timestamp(message.OccurredAtUtc)}}</span>
                <span class="message-meta" *ngIf="adminUserId">Läst: {{message.FirstReadAtUtc ? timestamp(message.FirstReadAtUtc) : 'Inte läst'}} · Push: {{pushStatus(message.PushStatus)}}</span>
              </div>
              <mat-icon aria-hidden="true">chevron_right</mat-icon>
            </a>
          </li>
        </ul>
        <mat-paginator [length]="vm.page.TotalCount" [pageIndex]="query.page" [pageSize]="query.pageSize" [pageSizeOptions]="[10,25,50]"
          [disabled]="vm.listLoading" (page)="pageChanged($event)" aria-label="Sidindelning av meddelanden"></mat-paginator>
      </div>
    </ng-container>

    <ng-template #messageDetail>
      <a mat-button class="back-link" [routerLink]="listRoute" [queryParams]="query"><mat-icon>arrow_back</mat-icon>Alla meddelanden</a>
      <div class="message-detail-area" [attr.aria-busy]="vm.detailLoading">
        <div *ngIf="vm.detailLoading" class="message-skeleton" role="status" aria-label="Hämtar meddelandet"><div class="message-skeleton-row" *ngFor="let row of skeletonRows" aria-hidden="true"><span></span></div></div>
        <div *ngIf="vm.detailError" role="alert"><p>{{vm.detailError}}</p><button mat-flat-button color="accent" (click)="retry()">Hämta igen</button></div>
        <article *ngIf="vm.detail as message" messageDisplayed (messageDisplayed)="displayed(message)">
          <span class="message-meta">{{message.Source === 'Personal' ? 'Personligt meddelande' : 'Allmän information'}} · {{timestamp(message.OccurredAtUtc)}}</span>
          <h2>{{message.Title}}</h2>
          <div class="message-content" [textContent]="message.Content"></div>
          <p class="message-meta" *ngIf="message.FirstReadAtUtc">Först läst {{timestamp(message.FirstReadAtUtc)}}</p>
          <p class="message-meta" *ngIf="!message.FirstReadAtUtc && vm.readOnly">Inte läst av medlemmen.</p>
          <div *ngIf="vm.readError" role="alert"><p>{{vm.readError}}</p><button mat-button (click)="retry()">Hämta igen</button></div>
          <div *ngIf="adminUserId" class="message-delivery"><p>Push: {{pushStatus(message.PushStatus)}}</p><p>Skickad till Apple betyder inte att notisen har visats eller lästs.</p></div>
          <a *ngIf="relatedRoute(message) as destination" mat-flat-button color="accent" [routerLink]="destination">{{message.RelatedLabel || 'Visa ärendet'}}</a>
        </article>
      </div>
    </ng-template>
  </div>
</section>
